import React, { useState } from 'react';
import { TextField } from '@mui/material';
import TableCell from '../../ui/table/tableCell/TableCell';
import TableRow from '../../ui/table/tableRow/TableRow';
import BaseActions from '../BaseActions/BaseActions';
import { BaseRowProps } from '../../../types/base';
import styles from './baseRow.module.sass';
import { useTranslation } from 'react-i18next';

const BaseRow: React.FC<BaseRowProps> = ({
  base,
  isAdmin,
  isAddedToCart,
  onAddToCart,
  onDeleteFromCart,
  onSaveChanges,
  onDelete,
}) => {
  const { t } = useTranslation();
  const [isEditing, setIsEditing] = useState(false);
  const [editedTitle, setEditedTitle] = useState(base.title);
  const [editedDescription, setEditedDescription] = useState(
    base.description || '',
  );
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    if (!onSaveChanges) return;

    setIsSaving(true);
    try {
      await onSaveChanges(base.id, editedTitle, editedDescription);
      setIsEditing(false);
    } catch (error) {
      console.error('Failed to save:', error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <TableRow className={styles.usersRow}>
      <TableCell className={styles.titleColumn}>
        {isEditing ? (
          <TextField
            variant="filled"
            value={editedTitle}
            className={styles.customTextfield}
            label={t('usersBases.baseName')}
            onChange={(e) => setEditedTitle(e.target.value)}
            disabled={isSaving}
            size="small"
            margin="none"
          />
        ) : (
          base.title
        )}
      </TableCell>

      <TableCell className={styles.descriptionColumn}>
        {isEditing ? (
          <TextField
            variant="filled"
            value={editedDescription}
            className={styles.customTextfield}
            label={t('adminBases.baseDescription')}
            onChange={(e) => setEditedDescription(e.target.value)}
            size="small"
            margin="none"
          />
        ) : (
          base.description || t('usersBases.noDescription')
        )}
      </TableCell>

      {isAdmin && (
        <TableCell className={styles.saleColumn}>
          {base.sale ? (
            <span className="material-icons">check</span>
          ) : (
            <span className="material-icons">close</span>
          )}
        </TableCell>
      )}

      <TableCell className={styles.creatColumn}>
        {new Date(base.created_at).toLocaleDateString('ru-RU')}
      </TableCell>

      <TableCell className={styles.dataCountColumn}>
        {base.data_count}
      </TableCell>

      <TableCell className={styles.chatsColumn}>
        {base.settings.parsed_chats.length > 0
          ? base.settings.parsed_chats.map((chat, index) => (
              <div key={index}>{chat}</div>
            ))
          : t('usersBases.noData')}
      </TableCell>

      {!isAdmin && (
        <TableCell className={styles.priceColumn}>25000 ₽</TableCell>
      )}

      <TableCell className={styles.buttonsColumn}>
        <BaseActions
          base={base}
          isAdmin={isAdmin}
          isAddedToCart={isAddedToCart}
          isEditing={isEditing}
          onEditToggle={() => setIsEditing(!isEditing)}
          onSave={handleSave}
          onCancel={() => {
            setIsEditing(false);
            setEditedTitle(base.title);
            setEditedDescription(base.description || '');
          }}
          onAddToCart={onAddToCart}
          onDeleteFromCart={onDeleteFromCart}
          onDelete={onDelete}
        />
      </TableCell>
    </TableRow>
  );
};

export default BaseRow;
